window.addEventListener('DOMContentLoaded', function () {
  //////// MENU BURGER
  var burger = document.querySelector('#btn-menu')
  var menu = document.querySelector('.Header')

  if (burger && menu) {
    burger.addEventListener('click', function () {
      var menuOpen = burger.getAttribute('aria-expanded') === 'true'

      if (!menuOpen) {
        burger.setAttribute('aria-expanded', true)
        menu.classList.add('open')
      } else {
        burger.setAttribute('aria-expanded', false)
        menu.classList.remove('open')
      }
    })
  }
})



if (window.innerWidth <= 992) {
  // Code JavaScript pour ajouter un bouton après chaque élément du menu ayant la classe "menu-item-has-children"
  document.addEventListener("DOMContentLoaded", function () {
    // Sélectionner tous les éléments du menu ayant la classe "menu-item-has-children"
    const menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children");

    // Parcourir chaque élément du menu ayant la classe "menu-item-has-children"
    menuItemsWithChildren.forEach(function (menuItem) {
      // Créer un nouvel élément de bouton (button)
      const button = document.createElement("button");
      button.textContent = "+"; // Texte initial du bouton

      // Ajouter une classe CSS au bouton si nécessaire
      button.classList.add("custom-button");

      // Ajouter le bouton après l'élément du menu
      menuItem.appendChild(button);
    });
  });

  // Gestionnaire d'événement "click" pour tout le menu
  document.addEventListener("click", function (event) {
    // Vérifier si l'élément cliqué est un bouton avec la classe "custom-button"
    if (event.target.classList.contains("custom-button")) {
      // Récupérer l'élément du menu parent (li) du bouton cliqué
      const menuItem = event.target.parentElement;

      // Basculer la classe "show" sur l'élément du menu parent pour afficher/masquer le sous-menu
      menuItem.classList.toggle("show");

      // Mettre à jour le texte du bouton en fonction de l'état du sous-menu
      const button = event.target;
      if (menuItem.classList.contains("show")) {
        button.textContent = "-"; // Texte du bouton lorsque le sous-menu est ouvert
      } else {
        button.textContent = "+"; // Texte du bouton lorsque le sous-menu est fermé
      }

      // Fermer tous les autres sous-menus sauf celui cliqué
      const menuItems = document.querySelectorAll(".menu-item-has-children");
      menuItems.forEach(function (otherMenuItem) {
        if (otherMenuItem !== menuItem && otherMenuItem.classList.contains("show")) {
          otherMenuItem.classList.remove("show");
          const otherButton = otherMenuItem.querySelector(".custom-button");
          otherButton.textContent = "+"; // Remettre le texte du bouton à "+"
        }
      });
    }
  });

}



var SousMenus = document.querySelectorAll('.menu-item-has-children');

function addMouseoverListener() {
  if (window.innerWidth >= 992) {
    SousMenus.forEach(function(SousMenu) {
      SousMenu.addEventListener('mouseover', function() {
        this.classList.add('open');
      });

      SousMenu.addEventListener('mouseout', function() {
        this.classList.remove('open');
      });
    });
  }
}

addMouseoverListener(); // Call the function initially

window.addEventListener('resize', addMouseoverListener); // Add event listener for window resize

    var SousMenu = document.querySelectorAll('.menu-item-has-children');

    SousMenu.forEach(function (index, value) {
        index.addEventListener('mouseover', function() {
            this.classList.add('open')
        })
        index.addEventListener('mouseout', function() {
            this.classList.remove('open')
        })
    });

   // Sous Menu
  
   var SousMenuP = document.querySelector('.sousMenuP');
   var SousMenuOpen = document.querySelector('.sousMenu');
   if (SousMenuP && SousMenuOpen) {
      SousMenuP.addEventListener('click', function(){
        var OpenIt = SousMenuP.getAttribute('aria-expanded') == 'true'

        if(!OpenIt){
          SousMenuP.setAttribute('aria-expanded', true)
          SousMenuOpen.classList.add('open')
        }else{
          SousMenuP.setAttribute('aria-expanded', false)
          SousMenuOpen.classList.remove('open')
        }
      })
    
   }



